import React, { useEffect, useState } from "react";
import { Handshake } from "lucide-react";
import api from "@/lib/api";
import { CARD, Label } from "@/components/common";
import { RetroSplit, SensBadge } from "@/components/retro/RetroSplit";
import { fmtEUR2 } from "@/lib/format";

export function RetroMonthCard({ year, month, refreshKey, onPaid }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    api.get(`/retrocessions?year=${year}&month=${month}`).then((r) => setRows(r.data.practitioners || [])).catch(() => setRows([]));
  }, [year, month, refreshKey, tick]);
  const collabs = (rows || []).filter((r) => r.encaisse_direct_mode);
  if (!collabs.length) return null;
  return (
    <div className={`${CARD} p-4 sm:p-6`} data-testid="retro-month-card">
      <Label className="mb-1">Rétrocessions du mois · qui a encaissé quoi</Label>
      <p className="mb-3 text-xs text-gray-500">Le collaborateur encaisse CB, espèces et chèques ; le cabinet encaisse Sécu / C2S, mutuelles et Alma. Le solde se met à jour à chaque saisie et à chaque virement reçu.</p>
      <div className="space-y-3">
        {collabs.map((r) => (
          <div key={r.practitioner.id} className="rounded-2xl border border-gray-100 p-3 sm:p-4">
            <button type="button" onClick={() => setOpen(open === r.practitioner.id ? null : r.practitioner.id)} data-testid={`retro-month-toggle-${r.practitioner.id}`}
              className="flex w-full flex-wrap items-center gap-2 text-left">
              <Handshake className="h-4 w-4 text-violet-600" />
              <span className="mr-auto text-sm font-semibold">{r.practitioner.name}</span>
              <span className="text-xs text-gray-500">CA {fmtEUR2(r.ca)} · déjà perçu {fmtEUR2(r.encaisse_direct)}</span>
              <SensBadge value={r.solde} /><b className="text-sm">{fmtEUR2(Math.abs(r.solde))}</b>
              {r.payment && <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-[#065F46]">Réglé</span>}
            </button>
            {open === r.practitioner.id && <div className="mt-3"><RetroSplit r={r} year={year} month={month} onChanged={() => { setTick((t) => t + 1); if (onPaid) onPaid(); }} /></div>}
          </div>
        ))}
      </div>
    </div>
  );
}
